<template>
  <div class="container-fluid base-container text-center welcome">
    <p class="accroche" v-html="$t('landing_components.welcome.title')"></p>
    <p class="subtext">{{ $t('landing_components.welcome.subtext') }}</p>
    <div class="cloud-part">
      <div class="cloud-img">
        <img src="/images/france.webp" alt="France">
      </div>
      <div class="cloud-txt">
        <div v-html="$t('landing_components.welcome.content', {certifs: $t('generics.certifications')})"></div>
        <div class="text-center">
          <b-link to="/datacenter"><b-button variant="success">{{ $t("landing_components.welcome.more_details") }} ></b-button></b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mirage"
}
</script>

<style scoped>


.welcome {
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.2)), url('/images/bg1.webp');
  padding: 100px 10px 30px;

}

.cloud-part {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.cloud-part .cloud-img {
  padding-right: 60px;
}

.cloud-part .cloud-txt {
  color: #f7f7f7;
  text-align: left;
  padding-bottom: 120px;
  font-size: 18px;
}

.cloud-txt {
  max-width: 1000px;
  text-align: justify;
}

.cloud-txt h3 {
  padding-left: 20px;
}

.cloud-txt p {
  padding-top: 20px;  text-align: justify;
}


.base-container .subtext {
  font-size: 24px;
  font-family: 'Prompt', sans-serif;
  color: #f7f7f7;
  margin-bottom: 70px;
  margin-top: -50px;
}


.cloud-txt p, .cloud-txt h3, .cloud-txt h2, .subtext {
  padding: 20px;
}

@media screen and (max-width: 1080px) {
  .cloud-img {
    display: none;
  }

  .cloud-txt p, .cloud-txt h3, .cloud-txt h2 {
    padding: 20px;
  }
}
</style>